<template>
  <div class="info_box">
    <sellheader></sellheader>
    <div class="content">
      <div
        :style="{ backgroundImage: 'url(' + backgroundImg + ')' }"
        style="background-size: cover; min-height: 300px; position: relative"
        class="inner-banner"
      >
        <section class="w3l-breadcrumb">
          <div class="container">
            <ul class="breadcrumbs-custom-path">
              <li><a href="./">首页</a></li>
              <li class="active">
                <a class="fa fa-chevron-right" href="/project">产品展示</a>
              </li>
              <li class="active">
                <span class="fa fa-chevron-right mx-2" aria-hidden="true"></span
                >产品详情
              </li>
            </ul>
          </div>
        </section>
      </div>
      <div class="project_info">
        <div class="project_img">
          <el-carousel
            :interval="5000"
            style="width: 90%; margin: auto"
            indicator-position="none"
            arrow="always"
          >
            <el-carousel-item v-for="item in projectList" :key="item">
              <el-image
                style="width: 100%; height: 100%"
                fit="contain"
                :src="item"
              ></el-image>
            </el-carousel-item>
          </el-carousel>
          <div class="img_num">1/1</div>

          <div class="project_title">
            <div class="j_info">
              <ul>
                <li>
                  <h3 class="hny-title text-center">
                    {{ projectInfo.productName }}
                  </h3>
                </li>
                <li>
                  <p>规格：{{ projectInfo.specs }}</p>
                </li>
                <li>
                  <p>
                    {{ projectInfo.indication }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div style="width: 80%; margin: auto; padding: 10px 0px 10px 0px">
          <el-divider content-position="center">简要产品资料</el-divider>
        </div>

        <div class="jian_info">
          <div class="jian_info_text">
            <p v-html="projectInfo.productContent"></p>
          </div>
        </div>
        <div v-if="projectInfo.instructionsPic != '' && projectInfo.instructionsPic != null" style="width: 80%; margin: auto; padding: 10px 0px 10px 0px">
          <el-divider content-position="center">说明书预览</el-divider>
        </div>
        <div v-if="projectInfo.instructionsPic != '' && projectInfo.instructionsPic != null" class="shuomingshu">
          <a  :href="projectInfo.instructionsPic != '' && projectInfo.instructionsPic != null" target="_blank">
            <div class="icon">
              <i class="iconfont icon-pdf"></i>
            </div>
            <div class="txt">
              <span>{{ projectInfo.productName }}产品说明书</span>
            </div>
            <div class="icon-last">
              <i class="iconfont icon-chakan1"></i>
            </div>
          </a>
        </div>
      </div>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import sellheader from "@/views/home/header/index.vue";
import footers from "@/views/footer/index.vue";

import { getprojectInfo } from "@/api/project/index";
import { bannerList } from "@/api/menu/index.js";

export default {
  components: {
    sellheader,
    footers,
  },
  data() {
    return {
      backgroundImg: null,
      projectList: [],
      projectInfo: {},
      imgqueryParams: {
        picType: "project",
      },
    };
  },
  mounted() {
    this.getProjectInfoById(this.getUrlKey("projectid"));
    this.getBannerList();
  },
  methods: {
    getBannerList() {
      bannerList(this.imgqueryParams).then((res) => {
        if (res.total > 0) {
          this.backgroundImg = res.rows[0].picUrl;
        }
      });
    },
    getProjectInfoById(id) {
      getprojectInfo(id).then((res) => {
        this.projectInfo = res.data;
        this.bannerImageList(res.data.picCode);
      });
    },

    bannerImageList(str) {
      this.projectList = str.split(",");
    },

    getUrlKey(name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || [, ""])[1].replace(/\+/g, "%20")
        ) || null
      );
    },
  },
};
</script>

<style lang="less" scoped>
.fa-chevron-right::before {
  font-size: 12px;
  margin-left: 10px;
  margin-right: 10px;
}
body,
html {
  width: 100%;
  height: 100%;
}
.content {
  width: 100%;
  height: 100%;
  background: #f2f2f2;
  padding-bottom: 60px;

  .project_img {
    width: 80%;
    margin: auto;
    background: #fff;
    .img_num {
      width: 100%;
      height: 30px;
      text-align: center;
    }
    .project_title {
      width: 80%;
      height: auto;
      margin: auto;

      .j_info {
        width: 80%;
        text-align: center;
        margin: auto;
        ul li:first-child {
          height: 80px;
        }
        ul li {
          h3 {
            line-height: 80px;
          }
          p {
            padding: 20px;
          }
          width: 100%;
          display: block;
          border-bottom: 1px solid #f2f2f2;
        }
      }
    }
  }
  .jian_info {
    width: 80%;
    margin: auto;
    // height: 400px;
    background: #fff;
    .jian_info_text {
      width: 80%;
      margin: auto;
      padding: 50px 10px 30px 10px;
    }
  }
  .shuomingshu {
    width: 80%;
    height: 100px;
    margin: auto;
    background: #fff;
    //   padding: 50px;
    .icon {
      width: 8%;
      height: 100px;
      // background: chartreuse;
      margin-left: 8%;
      float: left;
      .icon-pdf {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        background: #0a529b;
        border-radius: 5px;
        float: right;
        margin-top: 22%;
        color: #fff;
        font-size: 30px;
      }
    }
    .txt {
      width: 50%;
      height: 100px;
      margin-left: 1%;
      float: left;
      // background: chocolate;
      line-height: 100px;
      // font-size: 24px;
      color: #000;
      cursor: pointer;
    }
    .txt:hover {
      color: #651984;
    }
    .icon-last {
      float: right;
      margin-right: 60px;
      .icon-chakan1 {
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        float: right;
        font-size: 30px;
        margin-top: 50%;
      }
    }
  }
}
.el-divider__text {
  background: #f2f2f2 !important;
  color: #b2b2b2;
}
@media (min-width: 992px) {
  .txt {
    font-size: 24px;
  }
}
@media (max-width: 992px) {
  .content .shuomingshu .txt {
    font-size: 11px;
    margin-left: 5%;
    width: 55%;
  }
  .content .shuomingshu .icon .icon-pdf {
    margin-top: 90%;
    margin-left: 10px;
  }
  .content .shuomingshu .icon-last {
    margin-right: 0px;
  }
  .content .shuomingshu .icon {
    margin-left: 12%;
  }
  .el-carousel__container {
    height: 150px !important;
  }
  .hny-title {
    font-size: 18px;
  }
}
</style>